export const closeModalAfterApply = (arrangedId: string | null) => {
  if (arrangedId) {
    const currentPopoverButton = document.getElementById(arrangedId);

    if (currentPopoverButton) {
      currentPopoverButton.click();
    }
  }
};
